import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Edit from "./Edit";
import Save from "./save";
import "./style.scss";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="m17.3,5.4h2v2.9l-.3-.3c-.2-.2-.5-.2-.7,0s-.2.5,0,.7l1.2,1.1c.1.1.2.1.3.1s.2,0,.3-.1l1.2-1.1c.2-.2.2-.5,0-.7s-.5-.2-.7,0l-.3.3v-3.1c0-.2-.1-.5-.3-.6-.2-.1-.4-.2-.6-.2h-2.1c-.3,0-.5.2-.5.5s.3.5.5.5Z"
          stroke-width="0"
        />
        <path
          d="m5,9.8h7c1.8,0,3.2-1.5,3.2-3.2v-1c0-1.8-1.5-3.2-3.2-3.2h-7c-1.8,0-3.2,1.5-3.2,3.2v1c0,1.7,1.4,3.2,3.2,3.2Zm-1.8-4.3c0-1,.8-1.8,1.8-1.8h7c1,0,1.8.8,1.8,1.8v1c0,1-.8,1.8-1.8,1.8h-7c-1,0-1.8-.8-1.8-1.8v-1Z"
          stroke-width="0"
        />
        <path
          d="m19,13.2H5c-1.8,0-3.2,1.5-3.2,3.2v2c0,1.8,1.5,3.2,3.2,3.2h14c1.8,0,3.2-1.5,3.2-3.2v-2c0-1.7-1.4-3.2-3.2-3.2Zm1.8,5.3c0,1-.8,1.8-1.8,1.8H5c-1,0-1.8-.8-1.8-1.8v-2c0-1,.8-1.8,1.8-1.8h14c1,0,1.8.8,1.8,1.8v2Z"
          stroke-width="0"
        />
      </svg>
    ),
  },
});
